export default "__VITE_ASSET__Si3LDFG3__"